import React from 'react';
import CartService from '../service/CartService';
import ItemService from '../service/ItemService';
import ProfileService from '../service/ProfileService';
import { withRouter } from 'react-router';
import ImgIcon from '../assets/icons/img_icon.png';
import { Editor, EditorState } from 'draft-js'
import { stateFromHTML } from 'draft-js-import-html'
import AuthenticationService from '../service/AuthenticationService.js';
import { UNIT_1, UNIT_2, UNIT_3 } from '../util/Constant';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import SendIcon from '@mui/icons-material/Send';
import CryptoJS from 'crypto-js';
import { HiOutlineShoppingBag, HiOutlineEmojiSad, HiCheckCircle, HiOutlineEyeOff } from 'react-icons/hi';
import Price, { discountPercent } from '../components/Price';
import Skeleton from '../components/Skeleton';
import EmptyState from '../components/EmptyState';
import { notifyCartUpdated } from '../util/cartEvents';
import ShareProduct from '../components/ShareProduct';
import ProductGallery from '../components/ProductGallery';
import '../css/product.css'



const isLoggedIn = AuthenticationService.isUserLoggedIn();


class ViewItem extends React.Component {



    constructor(props) {
        super(props);
        this.state = {
            imageUrl: '',
            description: '',
            title: '',
            brandName: '',
            img1: null,
            img2: null,
            img3: null,
            selectedFile: null,
            itemId: null,
            currentImage: '',
            thump: null,
            thump1: null,
            thump2: null,
            thump3: null,
            isError: false,
            errorMsg: '',
            isLoading: false,
            showUploadAction: true,
            homeName: '',
            location: '',
            quantity: 1,
            unit: '',
            clickedBuy: false,
            isAvailable: false,
            price: '',
            unitType: UNIT_1,
            unitTypeNo: 0,
            unitName: '',
            newPrice: '',
            isSameUser: false,
            profileImage: '',
            outputHtml: null,
            pageUrl: '',
            sizeList: null,
            listItems: [],
            selectedId: null,
            selectedMrp: null,
            selectedDiscount: null,
            selectedFinalPrice: null,
            selectedDescription: null,
            selectedMaterial: null,
            selectedChestSize: null,
            selectedLength: null,
            width: window.innerWidth,
            isInCart: false,
            isAdding: false,
            cartError: '',
            loadError: false,
            isAdmin: AuthenticationService.getIsAdmin() === "true"

        };
        this.myRef = React.createRef();

    }



    onFileChange = event => {

        // Update the state
        this.setState({ selectedFile: event.target.files[0] });

    };



    onChangeQuantity = (event) => {
        const reg = new RegExp('^[0-9]+$');
        let newPrice = this.state.selectedFinalPrice * event.target.value
        if (reg.test(event.target.value)) {
            this.setState({
                quantity: event.target.value,
                newPrice: newPrice
            })
        } else if (event.target.value.length < 1) {
            this.setState({
                quantity: event.target.value,
                newPrice: this.state.price
            })
        }
    }

    onAddQuantity = () => {
        let newQuantity = this.state.quantity + 1
        if (newQuantity > 5) {
            alert("Can't add more than 5")
            return
        }
        let newPrice = this.state.selectedFinalPrice * newQuantity
        this.setState({
            quantity: newQuantity,
            newPrice: newPrice
        })
    }

    onSubtractQuantity = () => {
        let newQuantity = this.state.quantity - 1
        if (newQuantity < 1) {
            alert("Invalid")
            return
        }
        let newPrice = this.state.selectedFinalPrice * newQuantity
        this.setState({
            quantity: newQuantity,
            newPrice: newPrice
        })
    }

    onChangeUnit = (event) => {
        this.setState({
            unit: event.target.value
        })
    }
    onChangeUnit = (event) => {
        this.setState({
            unit: event.target.value
        })
    }
    openOrder = () => {
        this.setState({
            clickedBuy: true
        })
    }

    uploadImage = () => {
        // `current` points to the mounted file input element
        this.myRef.current.click();
        console.log("ref" + this.state.selectedFile)
    };

    uploaditemImg = () => {
        console.log("itemId" + this.state.itemId);
        const formData = new FormData();
        // Update the formData object
        formData.append("file", this.state.selectedFile);
        formData.append("itemId", this.state.itemId);
        this.setState({
            isLoading: true,
            showUploadAction: false
        })

        ItemService.addNewitemImage(formData).then(response => {

            if (response.status) {
                if (response.status == 200) {
                    // alert("Image Added Successfully")
                    window.location.reload();
                }
            }
        }).catch(error => {
            this.setState({
                isError: true,
                errorMsg: error.response.data.msg,
                isLoading: false
            })
        });

    };


    clickgrid = (value) => {
        console.log(value)
        this.setState({ currentImage: value });
    }

    selectSize = (value1, value2, value3, value4, value5, value6, value7, value8) => {
        console.log(value1)
        this.setState({
            selectedId: value1,
            selectedFinalPrice: value2,
            selectedMrp: value3,
            selectedDiscount: value4,
            newPrice: value2,
            selectedDescription: value5,
            selectedMaterial: value6,
            selectedChestSize: value7,
            selectedLength: value8
        });
    }

    exportHtml = (htmlData) => {
        this.setState({
            outputHtml: htmlData
        })
    }
    redirectConfirmationPage = () => {

        this.setState({ cartError: '' })
        ProfileService.isUserConfirmed().then(response => {

            if (response.status) {
                if (response.status == 200) {
                    this.props.history.push({
                        pathname: '/cart',
                        state: {
                            itemName: this.state.title,
                            quantity: this.state.quantity,
                            amount: this.state.newPrice.toString()
                        }
                    })
                    // window.location.reload();
                }

            }
        }).catch(error => {
            this.setState({
                isError: true,
                isLoading: false
            })
            const status = error?.response?.status
            if (status == 401) {
                this.props.history.push({
                    pathname: '/login',
                    state: { id: '/shop/items/view/' }
                })
            } else if (status == 400) {
                let encrypted = CryptoJS.AES.encrypt("/shop/items/view/" + this.state.itemId, "12345");
                this.props.history.push({
                    pathname: '/profile',
                    state: { id: '/shop/items/view/' + this.state.itemId }
                })
            } else {
                this.setState({ cartError: 'Could not open your cart. Please try again.' })
            }

        });


    }

    updateCart = () => {
        this.setState({
            isAdding: true,
            cartError: ''
        })

        const formData = new FormData();
        // Update the formData object
        // formData.append("cartId", this.state.itemId);
        formData.append("quantity", 1);
        formData.append("itemId", this.state.itemId);
        formData.append("itemSizeId", this.state.selectedId)

        CartService.updateCart(formData).then(response => {

            if (response.status) {
                if (response.status == 200) {

                    this.setState({
                        isError: false,
                        isLoading: false,
                        isAdding: false,
                        isInCart: true
                    })
                    notifyCartUpdated()
                }

            }
        }).catch(error => {
            this.setState({
                isError: true,
                isLoading: false,
                isAdding: false
            })
            const status = error?.response?.status
            if (status == 401) {
                this.props.history.push('/login')
            } else if (status == 400) {
                this.props.history.push({
                    pathname: '/userDetails',
                    state: { id: '/userDetails' }
                })
            } else {
                this.setState({ cartError: 'Could not add this item to your cart. Please try again.' })
            }

        });

    }

    componentDidMount() {
        this.loadItem()
    }

    loadItem = () => {
        let url = window.location.href
        this.setState({
            isLoading: true,
            loadError: false,
            notAvailable: false,
            pageUrl: url
        })
        ItemService.getMyPublicItemById(this.props.match.params.id).then(response => {
            console.log("hello - " + response.data.data)
            if (response.status) {
                let unitType = UNIT_1;
                let unitName = '';
                if (response.data.data.unitType == 1) {
                    unitType = UNIT_1
                    unitName = UNIT_1.find(o => o.id === response.data.data.unit).value;
                } else if (response.data.data.unitType == 2) {
                    unitType = UNIT_2
                    unitName = UNIT_2.find(o => o.id === response.data.data.unit).value;
                } else if (response.data.data.unitType == 3) {
                    unitType = UNIT_3
                    unitName = UNIT_3.find(o => o.id === response.data.data.unit).value;
                }
                this.setState({
                    imageUrl: response.data.data.imageUrl,
                    img1: response.data.data.imageUrl1,
                    img2: response.data.data.imageUrl2,
                    img3: response.data.data.imageUrl3,
                    title: response.data.data.title,
                    brandName: response.data.data.brandName || '',
                    // only sent while the staff switch "Show video" is on; the gallery shows it on phones
                    video: response.data.data.videoUrl ? {
                        url: response.data.data.videoUrl,
                        poster: response.data.data.videoPosterUrl,
                        first: !!response.data.data.videoFirst
                    } : null,
                    description: response.data.data.description,
                    outputHtml: response.data.data.description,
                    itemId: response.data.data.id,
                    currentImage: response.data.data.imageUrl,
                    thump: response.data.data.thump,
                    thump1: response.data.data.thump1,
                    thump2: response.data.data.thump2,
                    thump3: response.data.data.thump3,
                    homeName: response.data.data.guHomeName,
                    location: response.data.data.guHomeLocation,
                    isAvailable: response.data.data.isAvailable,
                    price: response.data.data.price,
                    unit: response.data.data.unit,
                    unitType: unitType,
                    unitName: unitName,
                    unitTypeNo: response.data.data.unitType,
                    isLoading: false,
                    isSameUser: response.data.data.isSameUser,
                    profileImage: response.data.data.profileImage,
                    isInCart: response.data.data.isInCart
                })
            } else {
                this.setState({ isLoading: false, loadError: true })
            }
        }).catch(error => {
            console.log(error)
            // 400 = hidden, deleted or unknown product: not a connection problem, so no "Try again"
            const notAvailable = !!(error && error.response && error.response.status === 400)
            this.setState({ isLoading: false, loadError: !notAvailable, notAvailable })
        });
        this.refreshItemSizes();
    }
    refreshItemSizes() {
        console.log("hitting refresh method")
        ItemService.getItemSizesPublic(this.props.match.params.id).then(res => {

            if (res.status) {

                this.setState({
                    sizeList: res.data.data,
                    listItems: res.data.data.itemSizeData,
                    selectedId: res.data.data.defaultItem.id,
                    selectedMrp: res.data.data.defaultItem.mrp,
                    selectedDiscount: res.data.data.defaultItem.discount,
                    selectedFinalPrice: res.data.data.defaultItem.finalPrice,
                    newPrice: res.data.data.defaultItem.finalPrice,
                    selectedDescription: res.data.data.defaultItem.description,
                    selectedMaterial: res.data.data.defaultItem.material,
                    selectedChestSize: res.data.data.defaultItem.chestSize,
                    selectedLength: res.data.data.defaultItem.length
                })


            }
        }).catch(error => {
            console.log(error)
        });
    }


    renderLoading() {
        return (
            <main className='mv-page mv-pdp' aria-busy='true'>
                <div className='mv-pdp-gallery'>
                    <Skeleton className='mv-pdp-main-skeleton' height='auto' radius='20px' />
                </div>
                <div className='mv-pdp-info'>
                    <Skeleton width='75%' height={30} />
                    <Skeleton width='40%' height={28} style={{ marginTop: 16 }} />
                    <Skeleton width='60%' height={44} style={{ marginTop: 24 }} />
                    <Skeleton width='100%' height={80} style={{ marginTop: 24 }} />
                </div>
            </main>
        )
    }

    renderCta() {
        const { isAvailable, isInCart, isAdmin, isAdding } = this.state
        if (!isAvailable) return null
        if (isInCart) {
            return (
                <button type='button' className='mv-btn mv-btn-success mv-pdp-cta-btn' onClick={this.redirectConfirmationPage}>
                    <HiCheckCircle size={20} /> Go to cart
                </button>
            )
        }
        return (
            <button
                type='button'
                className='mv-btn mv-btn-primary mv-pdp-cta-btn'
                onClick={this.updateCart}
                disabled={isAdmin || isAdding || !this.state.selectedId}
                title={isAdmin ? 'Admins cannot add items to a cart' : undefined}
            >
                <HiOutlineShoppingBag size={20} /> {isAdding ? 'Adding…' : 'Add to cart'}
            </button>
        )
    }

    render() {
        const { isLoading, loadError, title, brandName, isAvailable, currentImage, listItems, selectedId, selectedMrp, selectedFinalPrice } = this.state
        const { selectedDescription, selectedMaterial, selectedLength, cartError } = this.state

        if (this.state.notAvailable) {
            return (
                <main className='mv-page'>
                    <EmptyState
                        icon={<HiOutlineEyeOff />}
                        title="This product isn't available"
                        text="It may have sold out or been taken off the shop. Have a look at what's new instead."
                        actionLabel='Browse products'
                        onAction={() => this.props.history.push('/items/all')}
                    />
                </main>
            )
        }

        if (loadError) {
            return (
                <main className='mv-page'>
                    <EmptyState
                        icon={<HiOutlineEmojiSad />}
                        title='We could not load this product'
                        text='Please check your connection and try again.'
                        actionLabel='Try again'
                        onAction={this.loadItem}
                    />
                </main>
            )
        }

        if (isLoading) return this.renderLoading()

        const images = [
            { full: this.state.imageUrl, thumb: this.state.thump },
            { full: this.state.img1, thumb: this.state.thump1 },
            { full: this.state.img2, thumb: this.state.thump2 },
            { full: this.state.img3, thumb: this.state.thump3 }
        ].filter(img => img.full)
        const off = discountPercent(selectedMrp, selectedFinalPrice)
        const selectedSize = listItems && listItems.find(item => item.id === selectedId)

        return (
            <main className='mv-page mv-pdp'>
                <ProductGallery images={images} current={currentImage} title={title} onSelect={this.clickgrid}
                    video={this.state.video} />

                <section className='mv-pdp-info'>
                    {brandName && <p className='mv-pdp-brand'><span>Brand</span> {brandName}</p>}
                    <h1 className='mv-pdp-title'>{title}</h1>

                    <div className='mv-pdp-price'>
                        <Price finalPrice={selectedFinalPrice} mrp={selectedMrp} size='lg' />
                        {off > 0 && <span className='mv-chip mv-chip-discount'>{off}% OFF</span>}
                        <span className='mv-pdp-tax'>Inclusive of all taxes</span>
                    </div>

                    {listItems && listItems.length > 0 &&
                        <div className='mv-pdp-block'>
                            <div className='mv-pdp-label'>
                                Select size {selectedSize && <span>: {selectedSize.size}</span>}
                            </div>
                            <div className='mv-size-list' role='radiogroup' aria-label='Size'>
                                {listItems.map(item => {
                                    const soldOut = !(item.availableQuantity > 0)
                                    return (
                                        <button
                                            type='button'
                                            key={item.id}
                                            role='radio'
                                            aria-checked={item.id === selectedId}
                                            className={item.id === selectedId ? 'mv-size selected' : 'mv-size'}
                                            disabled={soldOut}
                                            title={soldOut ? 'Out of stock' : undefined}
                                            onClick={() => this.selectSize(item.id, item.finalPrice, item.mrp, item.discount, item.description, item.material, item.chestSize, item.length)}
                                        >
                                            {item.size}
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    }

                    {/* the server only sends a hidden product to staff (preview) */}
                    {!isAvailable &&
                        <div className='mv-alert mv-alert-info mv-pdp-block mv-pdp-hidden-note'>
                            <HiOutlineEyeOff aria-hidden='true' />
                            <span><strong>Hidden from the shop.</strong> Only staff can see this page. Turn on "On sale" in Inventory to sell it.</span>
                        </div>}

                    {isAvailable &&
                        <div className='mv-pdp-cta'>
                            <div className='mv-pdp-cta-price'>
                                <Price finalPrice={selectedFinalPrice} mrp={selectedMrp} />
                            </div>
                            {this.renderCta()}
                        </div>
                    }
                    {cartError && <div className='mv-alert mv-alert-error mv-pdp-block' role='alert'>{cartError}</div>}

                    {(selectedDescription || selectedMaterial || selectedLength) &&
                        <div className='mv-pdp-block mv-pdp-details'>
                            <h2 className='mv-pdp-subtitle'>Product details</h2>
                            {selectedDescription && <p className='mv-pdp-desc'>{selectedDescription}</p>}
                            <dl className='mv-pdp-specs'>
                                {selectedMaterial && <><dt>Material</dt><dd>{selectedMaterial}</dd></>}
                                {selectedLength && <><dt>Length</dt><dd>{selectedLength} inches</dd></>}
                            </dl>
                        </div>
                    }

                    {isAvailable &&
                        <ShareProduct itemId={this.state.itemId} title={this.state.title}
                            finalPrice={this.state.selectedFinalPrice} mrp={this.state.selectedMrp} />}
                </section>
            </main>
        );
    }
}

export default withRouter(ViewItem);
